import brandBackground from "../../assets/figma/auth/brand-background.png";
import featureLessons from "../../assets/figma/auth/welcome/feature-lessons.svg";
import featureTools from "../../assets/figma/auth/welcome/feature-tools.svg";
import clockIcon from "../../assets/figma/auth/welcome/icon-clock.svg";
import itemaLockup from "../../assets/figma/auth/welcome/itema-lockup.png";
import tagMark from "../../assets/figma/auth/welcome/tag-mark.svg";
import { loginBranding } from "../../data/auth/loginPage";

const FEATURE_ICONS = {
  lessons: featureLessons,
  tools: featureTools,
  students: featureTools,
};

export function LoginBrandingPanel() {
  return (
    <aside className="relative flex w-full overflow-hidden bg-black lg:sticky lg:top-0 lg:h-screen lg:w-1/2 lg:shrink-0">
      <img
        src={brandBackground}
        alt=""
        aria-hidden
        className="pointer-events-none absolute inset-0 h-full w-full object-cover opacity-20"
      />
      <div className="relative z-10 flex w-full flex-col justify-center px-8 py-12 sm:px-12 lg:px-16">
        <div className="max-w-[512px]">
          <div className="inline-flex items-center gap-1.5 rounded-full border border-[#c5c5d3] bg-[rgba(229,238,255,0.1)] px-3 py-1">
            <img src={tagMark} alt="" />
            <span className="font-inter text-[11px] font-semibold tracking-[0.55px] text-[#f19500]">
              {loginBranding.eyebrow}
            </span>
          </div>

          <div className="mt-4 flex flex-wrap items-center gap-3">
            <p className="font-inter text-[40px] font-bold leading-[48px] tracking-[-0.8px] text-white">
              {loginBranding.heading}
            </p>
            <img src={itemaLockup} alt="iTEMA" width={126} height={41} />
          </div>

          <p className="mt-4 font-inter text-lg leading-[29px] text-white">
            {loginBranding.description}
          </p>

          <ul className="mt-8 space-y-6">
            {loginBranding.features.map((feature) => (
              <li key={feature.id} className="flex items-start gap-4">
                <img src={FEATURE_ICONS[feature.id]} alt="" />
                <p className="font-inter text-base leading-6 text-white">{feature.text}</p>
              </li>
            ))}
          </ul>

          <div className="mt-10 border-t border-[#c5c5d3]/60 pt-6">
            <div className="flex items-center gap-3 rounded-xl border border-[#c5c5d3]/40 bg-white px-4 py-3.5 shadow-[0px_1px_1px_rgba(0,0,0,0.05)]">
              <span className="flex size-4 shrink-0 items-center justify-center rounded-lg border border-[#f19500] bg-[rgba(241,149,0,0.1)]">
                <img src={clockIcon} alt="" />
              </span>
              <p className="font-inter text-xs font-semibold tracking-[0.12px] text-[#1f2937]">
                {loginBranding.setupNote}
              </p>
            </div>
          </div>
        </div>
      </div>
    </aside>
  );
}
